// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1B_6H","label":"Labeled_label__26jLJ","divider":"Labeled_divider__YJ493"};